import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  Filler,
} from "chart.js";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  Filler
);

const LineChartWithPoint = (prop) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        display: true,
      },
    },
    scales: {
      x: {
        display: false,
        grid: {
          display: true,
          offset: false,
        },
        ticks: {
          align: "center",
        },
      },
      y: {
        display: false,
        grid: {
          display: false,
        },
      },
    },
  };
  let tmpdata = {
    labels: prop?.data?.["Chart Label"]
      ? prop?.data?.["Chart Label"]?.split(",")?.length > 1
        ? prop?.data?.["Chart Label"].split(",")
        : [new Date(), ...prop?.data?.["Chart Label"]?.split(",")]
      : [0, 0, 0, 0, 0],
    datasets:
      prop?.params === "CPU Usage"
        ? [
            {
              label: prop?.params,
              data: prop?.data?.[prop?.params]
                ? prop?.data?.[prop?.params]?.split(",")?.length > 1
                  ? prop?.data?.[prop?.params]?.split(",")
                  : [0, ...prop?.data?.[prop?.params]?.split(",")]
                : [0, 0, 0, 0, 0],
              borderColor: " #75BDE7",
              backgroundColor: "#E3F6FF",
              fill: true,
              tension: 0.4,
              pointRadius: 0,
            },
          ]
        : prop?.params === "Memory Usage"
        ? [
            {
              label: prop?.params,
              data: prop?.data?.[prop?.params]
                ? prop?.data?.[prop?.params]?.split(",")?.length > 1
                  ? prop?.data?.[prop?.params]?.split(",")
                  : [0, ...prop?.data?.[prop?.params]?.split(",")]
                : [0, 0, 0, 0, 0],
              borderColor: " #BC6CD4",
              backgroundColor: "#F4EAF7",
              fill: true,
              tension: 0.4,
              pointRadius: 0,
            },
          ]
        : [
            {
              label: prop?.params,
              data: prop?.data?.[prop?.params]
                ? prop?.data?.[prop?.params]?.split(",")?.length > 1
                  ? prop?.data?.[prop?.params]?.split(",")
                  : [0, ...prop?.data?.[prop?.params]?.split(",")]
                : [0, 0, 0, 0, 0],
              borderColor: " #D89965",
              backgroundColor: "#F7EEE7",
              fill: true,
              tension: 0.4,
              pointRadius: 0,
            },
          ],
  };

  return (
    <Line
      data={tmpdata}
      options={options}
      className=""
      style={{ width: 90, height: 25 }}
    />
  );
};

export default LineChartWithPoint;
